import ButtonCustom from '@ui/buttons/buttonCustom/ButtonCustom';
import React from 'react';
import {Link} from "react-router-dom";
import {useTranslation} from "react-i18next";
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import {buildLinkLinkToSnapshotsByTime} from "@containers/cameras/links/linkToSnapshotsByTime/helpers/buildLink";
import IconButtonCustom from "@ui/buttons/iconButtonCustom/IconButtonCustom";

interface IProps {
	dateFrom?: string
	dateTo?: string
	deviceId: number
	accountId: number
	iconOnly?: boolean
}

const LinkToSnapshotsByTime = ({
								   dateFrom,
								   deviceId,
								   dateTo,
								   accountId,
								   iconOnly,
							   }: IProps) => {
	const {t} = useTranslation()
	
	return (
		<Link to={buildLinkLinkToSnapshotsByTime({
			deviceId,
			dateTo,
			dateFrom,
			accountId,
		})}>
			{iconOnly ? <IconButtonCustom
				tooltip={t('base.photos')}
			>
				<CameraAltIcon fontSize={'small'} sx={{color: 'primary.main'}}/>
			</IconButtonCustom> : <ButtonCustom
				startIcon={<CameraAltIcon/>}
			>
				{t('base.photos')}
			</ButtonCustom>}
		</Link>
	);
};

export default LinkToSnapshotsByTime;